import React from 'react'
import { Slot } from 'radix-ui'

import { ampli } from '@/shared/lib/ampli'
import { useModals } from '@/shared/lib/modal-manager'

export const CreateScenario = ({
	children,
	optimizationGroupId,
}: {
	children: React.ReactNode
	optimizationGroupId: string
}) => {
	const { showModal } = useModals()
	const handleCreateScenario = () => {
		ampli.scenariosCreateScenario()
		showModal('CREATE_SCENARIO', { optimizationGroupId })
	}

	return <Slot.Root onClick={handleCreateScenario}>{children}</Slot.Root>
}
